import { useState } from 'react';
import { Label } from './ui/label';
import { Loader2, Upload, FileCheck } from 'lucide-react';
import api, { formatApiError } from '../lib/api';
import { toast } from 'sonner';

export default function FileUploader({ label, fileId, onUploaded, testId, required, accept = '.jpg,.jpeg,.png,.webp,.pdf' }) {
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState('');

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/uploads', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onUploaded(data.id, data.filename);
      setName(data.filename);
      toast.success(`${data.filename} uploaded`);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid={testId}>
      {label && (
        <Label className="text-xs font-semibold text-slate-600">
          {label}
          {required && <span className="text-red-500"> *</span>}
        </Label>
      )}
      <label className="mt-1 flex items-center gap-2 border border-dashed border-slate-300 rounded-xl px-4 py-3 cursor-pointer hover:border-[#3D4A8E] hover:bg-slate-50 transition-colors">
        {uploading ? (
          <Loader2 className="w-4 h-4 animate-spin text-slate-400" />
        ) : fileId ? (
          <FileCheck className="w-4 h-4 text-emerald-600" />
        ) : (
          <Upload className="w-4 h-4 text-slate-400" />
        )}
        <span className="text-sm text-slate-600 truncate">
          {uploading ? 'Uploading…' : fileId ? name || 'File uploaded' : 'Upload (JPG/PNG/PDF, ≤10MB)'}
        </span>
        <input
          type="file"
          accept={accept}
          className="hidden"
          onChange={(e) => upload(e.target.files?.[0])}
        />
      </label>
    </div>
  );
}
